export default "__VITE_ASSET__UUTbNrxD__"